import * as types from './types';
import { cloneDeep } from 'lodash';

const INITIAL_STATE = {
  selectedSites: [],
  sites: [],
  reimbursementRates: [],
  report: null,
  loading: false,
  loadingReport: false,
  error: null,
};

export default (state = INITIAL_STATE, { payload, type }) => {
  switch (type) {
    case types.REIMBURSEMENT_REPORT_GET_REIMBURSEMENT_RATES:
      return {
        ...state,
        reimbursementRates: payload.Data.sort(function(a, b) {
          return b.Id - a.Id;
        }),
      };

    case types.REIMBURSEMENT_REPORT_GET_ALL_SITES:
      let allowedSites = [];

      if (payload && payload.length > 0) {
        allowedSites = payload.filter(
          s => s.IsActive === true && s.IsLicensed === true
        );
      }

      return {
        ...state,
        sites: allowedSites,
      };

    case types.REIMBURSEMENT_REPORT_INITIAL_LOADING:
      return {
        ...state,
        loading: payload,
        loadingReport: false,
      };

    case types.REIMBURSEMENT_REPORT_UPDATE_SELECTED_SITES:
      const currentSites = cloneDeep(state.selectedSites);
      let newSites = currentSites;

      if (payload.checked === true) {
        newSites.push(payload.siteId);
      } else {
        newSites = newSites.filter(x => x !== payload.siteId);
      }

      return {
        ...state,
        selectedSites: newSites,
      };

    case types.REIMBURSEMENT_REPORT_SELECT_ALL_SITES:
      const allSites = cloneDeep(state.sites);

      if (payload === true) {
        return {
          ...state,
          selectedSites: allSites.map(x => x.Id),
        };
      } else {
        return { ...state, selectedSites: [] };
      }

    case types.REIMBURSEMENT_REPORT_LOADING:
      return {
        ...state,
        loading: payload,
        loadingReport: payload,
      };

    case types.REIMBURSEMENT_REPORT_GET_REPORT:
      return {
        ...state,
        report: payload,
      };

    case types.REIMBURSEMENT_REPORT_ERROR:
      return {
        ...state,
        error: payload,
      };
    case types.REIMBURSEMENT_REPORT_CLEAR_REPORT:
      return {
        ...state,
        report: null,
        error: null,
      };

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/pages/reimbursement/state/report/reducer.js